import { Component, ViewChild, AfterViewInit, OnInit, Inject, ElementRef } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpParams, HttpResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common-service';

//grid
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxDropDownListComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownlist';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxWindowComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxwindow';
import { jqxEditorComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxeditor';
import { jqxLoaderComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxloader';

import { MasterService } from '../services/master-service';

@Component({
  templateUrl: '../main.component.html'
})

export class RemindListComponent implements OnInit {
  public menuName = "Master";
  public titleName = "Remind";
  public clickOpen = "Rowdoubleclick($event)";
  //public rowscount = 0;
  public edited = true;
  public isSearchDate = false;
  @ViewChild('cellBeginEditLog') cellBeginEditLog: ElementRef;
  @ViewChild('cellEndEditLog') cellEndEditLog: ElementRef;
  @ViewChild('myGrid') myGrid: jqxGridComponent;
  @ViewChild('myDropDownList') myDropDownList: jqxDropDownListComponent;
  @ViewChild('myInput') myInput: jqxInputComponent;
  @ViewChild('myWindow') myWindow: jqxWindowComponent;
  @ViewChild('MyLoader') MyLoader: jqxLoaderComponent;

  delrows: Array<any> = [];
  selectedcell: any;
  errorMessage: any;
  successMessage: any;
  first_flg: boolean = true;
  loading_flg: boolean = true;

  //get grid source
  constructor(
    private _masterService: MasterService,
    private _router: Router, private _com: CommonService,
    public dialog: MatDialog) {
  }

  ngOnInit() {
    this.getReminds();
  }

  //tool bar
  ngAfterViewInit(): void {
    this.createButtons();
  }

  getReminds() {
    this.loading_flg = true;
    if (!(this.first_flg)) {
      this.MyLoader.open();
    }
    this._masterService.getReminds(false).subscribe((data) => {
      this.source.localdata = data;
      //this.rowscount = data.length;
      this.dataAdapter.dataBind();
      if (!(this.first_flg)) {
        this.MyLoader.close();
      }
      this.first_flg = false;
      this.loading_flg = false;
    });
  }

  dropDownSource: string[] = ['Id','Subject','Description','Contents','Inactive'];
  groups: any[] = [];
  getPagesize(): any {
    return 20;
  }
  //grid 
  source: any =
    {
      datatype: 'json',
      datafields: [
        { name: 'remind_id', type: 'int' },
        { name: 'description', type: 'string' },
        { name: 'email_subject', type: 'string' },
        { name: 'email_contents', type: 'string' },
        { name: 'inactive', type: 'bool' }
      ],
      id: 'remind_id',
      localdata: {},
      sortcolumn: 'remind_id'
    };
  dataAdapter: any = new jqx.dataAdapter(this.source);

  getWidth(): any {
    return '100%';
  }
  getTotal(): any {
    return false;
  }
  //columns
  columns: any[] =
    [
      { text: 'Id', datafield: 'remind_id', width: '5%', align: 'right', cellsalign: 'right', columntype: 'textbox', editable: false },
      {
        text: 'Description', datafield: 'description', width: '20%', columntype: 'textbox', editable: false,
        validation: (cell: any, value: any): any => {
          if (value.length > 50) {
            return { result: false, message: 'Description must be less than 50 letters.' };
          }
          return true;
        }
      },
      {
        text: 'Subject', datafield: 'email_subject', width: '40%', columntype: 'textbox', editable: false,
      },
      {
        text: 'Contents', datafield: 'email_contents', width: '25%', columntype: 'textbox', editable: false,
        validation: (cell: any, value: any): any => {
          if (value.length > 30000) {
            return { result: false, message: 'Contents must be less than 30000 letters.' };
          }
          return true;
        }
      },
      { text: 'Inactive', datafield: 'inactive', width: '10%', columntype: 'checkbox', twostatecheckbox: true, align: 'center', editable: false}
    ];

  //Popup
  Rowdoubleclick(event: any): void {
    let selectedrowindex = this.myGrid.getselectedrowindex();
    let id = this.myGrid.getrowdata(selectedrowindex).remind_id;
    let dialogRef = this.dialog.open(PopupRemindComponent, {
      width: '1000px',
      //height: 'auto*',
      disableClose: true,//20191007 close無し
      data: {
        remind_id: id
      }
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        //20191008 自分のタイミングで更新するように
        //this.getReminds();
    });
  }

  groupsrenderer(text, group, expanded, data): any {
   var color;
    switch (data.level) {
      case 0:
        color = '#B0BEC5';
        break;
      case 1:
        color = '#CFD8DC';
        break;
      case 2:
        color = '#ECEFF1';
        break;
      case 3:
        color = '#EEEEEE';
        break;
      case 4:
        color = '#F5F5F5';
        break;
      case 5:
        color = '#FAFAFA';
        break;
    } 
    return '<div style="width: 100%; height: 100%; background-color: #CFD8DC; color:Black; line-height:30px;"><span style="font-weight:bold; vertical-align: middle;">' + text + '</span></div>';
  }

  //add row
  generatedata(): any {
    let row = {};
    row['remind_id'] = 0;
    row['description'] = "";
    row['email_subject'] = "";
    row['email_contents'] = "";
    row['inactive'] = false;

    return row;
  }

  //tool buttons
  createButtonsContainers(statusbar: any): void {
    let buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = 'overflow: hidden; position: relative; margin: 5px;';
    let addButtonContainer = document.createElement('div');
    //let deleteButtonContainer = document.createElement('div');
    let reloadButtonContainer = document.createElement('div');
    //let searchButtonContainer = document.createElement('div');
    //let saveButtonContainer = document.createElement('div');
    addButtonContainer.id = 'addButton';
    //deleteButtonContainer.id = 'deleteButton';
    reloadButtonContainer.id = 'reloadButton';
    //searchButtonContainer.id = 'searchButton';
    //saveButtonContainer.id = 'saveButton';
    addButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //deleteButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    reloadButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //searchButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //saveButtonContainer.style.cssText = 'float: right; margin-right: 5px;';
    addButtonContainer.className = 'btn btn-default';
    //deleteButtonContainer.className = 'btn btn-default';
    reloadButtonContainer.className = 'btn btn-default';
    //searchButtonContainer.className = 'btn btn-default';
    //saveButtonContainer.className = 'btn btn-default';
    buttonsContainer.appendChild(addButtonContainer);
    //buttonsContainer.appendChild(deleteButtonContainer);
    buttonsContainer.appendChild(reloadButtonContainer);
    //buttonsContainer.appendChild(searchButtonContainer);
    //buttonsContainer.appendChild(saveButtonContainer);
    statusbar[0].appendChild(buttonsContainer);
  }

  //create tool buttons
  createButtons(): void {
    let addButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-plus' style='color:darkseagreen;' title='Add'></span>"
    }
    let addButton = jqwidgets.createInstance('#addButton', 'jqxButton', addButtonOptions);
    //let deleteButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-remove' style='color:indianred;' title='Delete'></span>"
    //}
    //let deleteButton = jqwidgets.createInstance('#deleteButton', 'jqxButton', deleteButtonOptions);
    let reloadButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-refresh' style='color:darkblue;' title='Reload'></span>"
    }
    let reloadButton = jqwidgets.createInstance('#reloadButton', 'jqxButton', reloadButtonOptions);
    //let searchButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-search' style='color:slategrey;' title='Find'></span>"
    //}
    //let searchButton = jqwidgets.createInstance('#searchButton', 'jqxButton', searchButtonOptions);
    //let saveButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-floppy-disk' style='color:#2E7D32;' title='Save'></span>"
    //}
    //let saveButton = jqwidgets.createInstance('#saveButton', 'jqxButton', saveButtonOptions);

    // add new row.
    addButton.addEventHandler('click', (event: any): void => {
      let id = 0;
      let dialogRef = this.dialog.open(PopupRemindComponent, {
        width: '900px',
        //height: 'auto*',
        disableClose: true,//20191007 close無し
        data: {
          remind_id: id
        }
      });
      dialogRef.afterClosed().subscribe(
        (result) => {
          //20191008 自分のタイミングで更新するように
          //this.getReminds();
        });
    });
    // delete selected row.
    //deleteButton.addEventHandler('click', (event: any): void => {
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  let rowscount = this.myGrid.getdatainformation().rowscount;
    //  let id = this.myGrid.getrowid(selectedrowindex);
    //  this.myGrid.deleterow(id);
    //  this.delrows.push(id);
    //});
    // reload grid data.
    reloadButton.addEventHandler('click', (event: any): void => {
      this.getReminds();
      this.delrows = [];
      this.selectedcell = null;
    });
    // search for a record.
    //searchButton.addEventHandler('click', (event: any): void => {
    //  this.myWindow.open();
    //  this.myWindow.move(60, 60);
    //});
    // save records.
    //saveButton.addEventHandler('click', (event: any): void => {
    //  this.errorMessage = null;
    //  this.successMessage = 'You have successfully saved the data.';

    //  //confirm changes
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  this.myGrid.endcelledit(selectedrowindex, this.selectedcell, false);

    //  for (var i = 0; i < this.myGrid.getrows().length; i++) {
    //    let remind = this.myGrid.getrowdata(i);
    //    if (remind.description.length > 50
    //      || remind.email_contents.length > 5000) {
    //      this.errorMessage = "Input is invalid. Please check the data.";
    //      this.successMessage = null;
    //      return;
    //    }
    //  }

    //  let rows = this.myGrid.getrows();

    //  rows.forEach(remind => {
    //    if (remind.remind_id == 0) {
    //      this._masterService.addRemind(remind)
    //        .subscribe(
    //          data => {
    //            //this.getReminds();
    //            let index = this.myGrid.getrowboundindexbyid(remind.remind_id);
    //            remind.remind_id += data;
    //            this.myGrid.setcellvalue(index, "remind_id", data);
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //    else {
    //      this._masterService.updateRemind(remind)
    //        .subscribe(
    //          data => {
    //          //this.getReminds();
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //  });
    //  this.delrows.forEach(remindId => {
    //    if (remindId != "0") {
    //      this._masterService.deleteRemind(remindId).subscribe(
    //        data => {
    //          //this.getReminds();
    //          if (data != 1) {
    //            this.errorMessage += "Data has not been found : ID " + remindId;
    //          }
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //  });
    //  this.delrows = [];
    //  this.selectedcell = null;
    //});
  }

  //find button
  findBtnOnClick(): void {
    this.myGrid.clearfilters();
    let searchColumnIndex = this.myDropDownList.selectedIndex();
    let datafield = '';
    switch (searchColumnIndex) {
      case 0:
        datafield = 'remind_id';
        break;
      case 1:
        datafield = 'description';
        break;
      case 2:
        datafield = 'email_subject';
        break;
      case 3:
        datafield = 'email_contents';
        break;
      case 4:
        datafield = 'inactive';
        break;
    }
    let searchText = this.myInput.val();
    let filtergroup = new jqx.filter();
    let filter_or_operator = 1;
    let filtervalue = searchText;
    let filtercondition = 'contains';
    let filter = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
    filtergroup.addfilter(filter_or_operator, filter);
    this.myGrid.addfilter(datafield, filtergroup);
    // apply the filters.
    this.myGrid.applyfilters();
  }

  //clear btn
  clearBtnOnClick(): void {
    this.myGrid.clearfilters();
  }

  //edit function
  rowValues: string = '';
  myGridOnCellBeginEdit(event: any): void {
    let args = event.args;
    this.selectedcell = args.datafield;
  };
  myGridOnCellEndEdit(event: any): void {
  };

  //print pdf
  btnOnClick() {
    let gridContent = this.myGrid.exportdata('html');
    let newWindow = window.open('', '', 'width=800, height=500'),
      document = newWindow.document.open(),
      pageContent =
        '<!DOCTYPE html>\n' +
        '<html>\n' +
        '<head>\n' +
        '<meta charset="utf-8" />\n' +
        '<title>Remind - Report</title>\n' +
        '</head>\n' +
        '<body>\n' + gridContent + '\n</body>\n</html>';
    document.write(pageContent);
    document.close();
    newWindow.print();
  };

  //export excel
  excelBtnOnClick() {
    this.myGrid.exportdata('xls', 'Remind');
  };

  onPageChanged(): void {
    this.myGrid.expandallgroups();
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }
}

//Popup
@Component({
  selector: 'app-popup-remind',
  templateUrl: 'popup-remind.component.html',
  styleUrls: ['./master-popup.component.css'],
})
export class PopupRemindComponent implements OnInit {
  @ViewChild('editorEmail') myEditor: jqxEditorComponent;
  title: string = "(Create)";
  Form: FormGroup;
  errorMessage: any;
  successMessage: any;
  selectedcell: any;
  delrows: Array<any> = [];
  user: any;

  ToolsRemind: string = 'customer | startdate | enddate | font | size | color | bold  italic underline ';

  createCommandRemind = (name: string): any => {
    switch (name) {
      case 'customer':
        return {
          type: 'button',
          tooltip: 'Insert Name',
          init: (widget: any): void => {
            widget.jqxButton({ width: 100 });
            widget.html('<span style="line-height: 24px;">Customer</span>');
          },
          refresh: (widget: any, style: any): void => {
            // do something here when the selection is changed.
          },
          action: (widget: any, editor: any): any => {
            return { command: 'inserthtml', value: '[ParaCustomerName]' };
          }
        }
      case 'startdate':
        return {
          type: 'list',
          tooltip: 'Insert Start Date',
          init: (widget: any): void => {
            widget.jqxDropDownList({ placeHolder: 'Start Date', width: 170, source: ['和:〇年〇月〇日(〇曜日)', '英:yyyy/MM/dd (ddd)'], autoDropDownHeight: true });
            //widget.jqxButton({ height: 25 });
            //widget.html('<span style="line-height: 24px;">End Date(Jap)</span>');
          },
          refresh: (widget: any, style: any): void => {
            // do something here when the selection is changed.
            widget.jqxDropDownList('clearSelection');
          },
          action: (widget: any, editor: any): any => {
            let widgetValue = widget.val();
            return { command: 'inserthtml', value: widgetValue == '和:〇年〇月〇日(〇曜日)' ? '[ParaStartDateJ]' : '[ParaStartDateE]' };
            //return { command: 'inserthtml', value: '[ParaEndDateJ]' };
          }
        }
      case 'enddate':
        return {
          type: 'list',
          tooltip: 'Insert End Date',
          init: (widget: any): void => {
            widget.jqxDropDownList({ placeHolder: 'End Date', width: 170, source: ['和:〇年〇月〇日(〇曜日)', '英:yyyy/MM/dd (ddd)'], autoDropDownHeight: true });
            //widget.jqxButton({ height: 25 });
            //widget.html('<span style="line-height: 24px;">End Date(Jap)</span>');
          },
          refresh: (widget: any, style: any): void => {
            // do something here when the selection is changed.
            widget.jqxDropDownList('clearSelection');
          },
          action: (widget: any, editor: any): any => {
            let widgetValue = widget.val();
            return { command: 'inserthtml', value: widgetValue == '和:〇年〇月〇日(〇曜日)' ? '[ParaEndDateJ]' : '[ParaEndDateE]' };
            //return { command: 'inserthtml', value: '[ParaEndDateJ]' };
          }
        }
    }
  };

  //localization: any = {
  //    'bold': 'Fett',
  //    'italic': 'Kursiv',
  //    'underline': 'Unterstreichen',
  //    'format': 'Block-Format',
  //    'font': 'Schriftname',
  //    'size': 'Schriftgröße',
  //    'color': 'Textfarbe',
  //    //'background': 'Hintergrundfarbe',
  //    //'left': 'Links ausrichten',
  //    //'center': 'Mitte ausrichten',
  //    //'right': 'Rechts ausrichten',
  //    //'outdent': 'Weniger Einzug',
  //    //'indent': 'Mehr Einzug',
  //    //'ul': 'Legen Sie ungeordnete Liste',
  //    //'ol': 'Geordnete Liste einfügen',
  //    //'image': 'Bild einfügen',
  //    //'link': 'Link einfügen',
  //    //'html': 'html anzeigen',
  //    //'clean': 'Formatierung entfernen'
  //};
  constructor(
    public dialogRef: MatDialogRef<PopupRemindComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _masterService: MasterService,
    private _authService: AuthService,
    private _fb: FormBuilder, private _com: CommonService
  ) {
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.user = this._authService.getAuthLoginName();
    this.Form = this._fb.group({
      remind_id: 0,
      description: ['', Validators.required],
      email_subject: '',
      email_contents: '',
      updated_by: this.user,
      updated_date: todayStr,
      inactive: false
    })
  }

  ngOnInit() {
    this.getRemindById(this.data.remind_id);
  }

  ngAfterViewInit(): void
  {
      this.myEditor.createComponent({ });
  }   

  getRemindById(id) {
    if (id > 0) {
      this.title='(Edit/View)'
      this._masterService.getRemindById(id)
        .subscribe(
        res => {
          this.Form.setValue(res);
          this.myEditor.val(res.email_contents);
        },
        error => this.errorMessage = error._body
      );
    }
  }

  getWidth(): any {
    return '100%';
  }

  getHeight(): any {
    return '70%';
  }

  //Save Data
  saveRemind() {
    //check form
    if (this.Form.invalid) {
      this.errorMessage = 'Please enter all required fields.';
      return;
    }

    this.errorMessage = null;
    this.successMessage = null;
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.Form.value.updated_by = this.user;
    this.Form.value.updated_date = todayStr;
    this.Form.value.email_contents = this.myEditor.val();
    if (this.remind_id.value == 0) {
      this._masterService.addRemind(this.Form.value)
        .subscribe(
          data => {
            if (data > 0) {
                this.successMessage = "You have successfully added the data.";
                this.getRemindById(data);
            } else {
              this.errorMessage = "Failed to save the data. ";
            }
        },
        error => {
          this.successMessage = null;
          if (error != null) {
            this.errorMessage = error._body;
          }
          else {
            this.errorMessage = "Failed to save the data. ";
          }
        });
    }
    else {
      this._masterService.updateRemind(this.Form.value)
        .subscribe(
          data => {
            if (data > 0) {
              this.successMessage = "You have successfully updated the data.";
              this.getRemindById(data);
            } else {
              this.errorMessage = "Failed to update the data. ";
            }
        },
        error => {
          this.successMessage = null;
          if (error != null) {
            this.errorMessage = error._body;
          }
          else {
            this.errorMessage = "Failed to update the data. ";
          }
        });
    }
  }

  //Delete Data
  deleteRemind() {
    if (!confirm("Are you sure you want to delete this data?")) {
      console.log('no');
      return;
    }

    if (this.remind_id.value != 0) {

      let id = this.remind_id.value;

      this._masterService.deleteRemind(id)
        .subscribe(
          data => {
            if (data == 1) {
              this.dialogRef.close();
            }
            else {
              this.errorMessage = ' Failed to delete the data.';
            }
          },
          error => {
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to delete the data. ";
            }
          }
        )
    };
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }

  get remind_id() { return this.Form.get('remind_id'); }
  get description() { return this.Form.get('description'); }
  get email_subject() { return this.Form.get('email_subject'); }
  get email_contents() { return this.Form.get('email_contents'); }
  get inactive() { return this.Form.get('inactive'); }
  get updated_by() { return this.Form.get('updated_by'); }
  get updated_date() { return this.Form.get('updated_date'); }
}




// WEBPACK FOOTER //
// ./src/app/master/remind-list.component.ts